module.exports = __webpack_public_path__ + "static/media/pdf-type-cover.28cc1621.svg";